import { InventoryAvailabilityStatus } from '../../../core/apis/inventoryApi';
/**
 * Returns an array of vehicles that have model id's and colour codes with the provided inventory status.
 *
 * @param filteredVehicles - The array of vehicles to filter.
 * @param inventoryStatus - The inventory status to filter by.
 * @returns The filtered array of vehicles.
 */
export const getVehiclesByInventoryStatus = (filteredVehicles, inventoryStatus) => {
    const vehicles = filteredVehicles.filter(v => {
        var _a;
        const transmissions = v.transmissions || [];
        // Assume one transmission per card
        const transmission = transmissions[0];
        const exteriorColor = (_a = transmission === null || transmission === void 0 ? void 0 : transmission.exteriorColors) === null || _a === void 0 ? void 0 : _a.find(c => c.key === (transmission === null || transmission === void 0 ? void 0 : transmission.exteriorColorKey));
        const interiorColor = exteriorColor === null || exteriorColor === void 0 ? void 0 : exteriorColor.interiorColors.find(c => c.key === (transmission === null || transmission === void 0 ? void 0 : transmission.interiorColorKey));
        return ((inventoryStatus === InventoryAvailabilityStatus.inStock && (interiorColor === null || interiorColor === void 0 ? void 0 : interiorColor.inStock)) ||
            (inventoryStatus === InventoryAvailabilityStatus.onItsWay && (interiorColor === null || interiorColor === void 0 ? void 0 : interiorColor.onItsWay)));
    }) || [];
    return vehicles.map(v => ({ ...v, inventoryStatus }));
};
export default getVehiclesByInventoryStatus;
